import api from "./api";
import URLS from "../utils/urls.js";

export const bucketsList = () => {
  return api.get(URLS.BACKEND_API + `/s3/`);
};

export const getBucketFolders = bucketName => {
  return api.get(`${URLS.BACKEND_API}/s3/${bucketName}/`);
};

export const getDateFolderContents = (bucketName, dateFolder) => {
  return api.get(URLS.BACKEND_API + `/s3/${bucketName}/${dateFolder}/`);
};

export const getPerformanceFolderContents = (
  bucketName,
  dateFolder,
  performanceFolder
) => {
  return api.get(
    URLS.BACKEND_API + `/s3/${bucketName}/${dateFolder}/${performanceFolder}/`
  );
};

export const getRH20KMIDContents = (
  bucketName,
  dateFolder,
  performanceFolder,
  rh20kmidFolder
) => {
  return api.get(
    URLS.BACKEND_API +
      `/s3/${bucketName}/${dateFolder}/${performanceFolder}/${rh20kmidFolder}/`
  );
};

export const getSignedFileUrl = path => {
  return api.get(URLS.BACKEND_API + `/s3/${path}`);
};
